import React from 'react'

import classNames from 'classnames'

import { useAudioPreview } from '@providers/AudioPreviewProvider'

interface Props {
  id: string
  url?: string | null
  hasCustomAudioMedia?: boolean
  className?: string
}

const AudioPreview: React.FC<Props> = ({ id, url, className }: Props) => {
  const { isPlaying, startPreview, stopPreview } = useAudioPreview()

  return (
    <button
      disabled={!url}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()

        if (isPlaying(id)) stopPreview()
        else if (url) startPreview(url, id)
      }}
      className={classNames(
        'flex-col justify-center items-center group-hover:flex disabled:cursor-not-allowed',
        isPlaying(id) ? 'flex' : 'hidden',
        className
      )}>
      {url ? (
        <>
          {isPlaying(id) ? (
            <>
              <i className="nf-icon nf-speaker block group-hover:hidden" />
              <i className="nf-icon nf-stop hidden group-hover:block" />
            </>
          ) : (
            <i className="nf-icon nf-play" />
          )}
        </>
      ) : (
        <i className="nf-icon nf-playoff" />
      )}
    </button>
  )
}

export default AudioPreview
